export default "{\n    \"emptyText\": \"Cliquez pour sélectionner une catégorie\",\n    \"placeholderText\": \"Rechercher pour filtrer...\"\n}\n"